class StandardsCard extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this._inner = this.querySelector('.standards-card__inner');
    this._front = this.querySelector('.standards-card__front');
    this._back = this.querySelector('.standards-card__back');
    this._closeBtn = this.querySelector('.standards-card__close');
    this._glassIcon = this.querySelector('.glass-icon');
    this._flipped = false;

    this._observeEntry();

    this.addEventListener('mouseenter', () => {
      if (this._isMobile()) return;
      this._flip(true);
    });

    this.addEventListener('mouseleave', () => {
      if (this._isMobile()) return;
      this._flip(false);
    });

    this._front.addEventListener('click', () => {
      if (!this._isMobile()) return;
      this._flip(true);
    });

    if (this._closeBtn) {
      this._closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this._flip(false);
      });
    }
  }

  _isMobile() {
    return window.innerWidth < 1024;
  }

  _observeEntry() {
    if (this._isMobile()) return;

    this.style.opacity = '0';
    this.style.transform = 'translateY(40px)';

    const index = parseInt(this.dataset.index) || 0;
    const section = this.closest('section') || this.parentElement;

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.animate([
          { opacity: 0, transform: 'translateY(40px)' },
          { opacity: 1, transform: 'translateY(0)' },
        ], {
          duration: 800,
          delay: index * 195,
          easing: 'linear',
          fill: 'forwards',
        });
        observer.disconnect();
      }
    }, { threshold: 0.15 });

    observer.observe(section);
  }

  _flip(open) {
    if (this._flipped === open) return;
    this._flipped = open;

    if (this._glassIcon) {
      this._glassIcon.style.opacity = open ? '0' : '';
    }

    gsap.to(this._inner, {
      rotationY: open ? 180 : 0,
      duration: 0.45,
      ease: 'power2.inOut',
      onUpdate: () => {
        const r = gsap.getProperty(this._inner, 'rotationY');
        const past = r > 90;
        this._front.style.visibility = past ? 'hidden' : 'visible';
        this._back.style.visibility = past ? 'visible' : 'hidden';
      }
    });
  }
}

customElements.define('standards-card', StandardsCard);
